import { render, staticRenderFns } from "./PMgEtfKbus.vue?vue&type=template&id=35f82e10&scoped=true"
import script from "./PMgEtfKbus.vue?vue&type=script&lang=js"
export * from "./PMgEtfKbus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f82e10",
  null
  
)

export default component.exports